<div *ngIf="!loading && !loadingPermission && dataTable && dataTable.length > 0">
  <form>
    <div class="table-container mt-4">
      <h4 *ngIf="settings.showTitle" style="padding-left: 2rem">{{ name }}</h4>

      <div class="riquadro" [style.overflow-x]="'auto'" [ngStyle]="settings.showBackground === false ? {
        'background-color': 'white',
        'padding-left': '0',
        'padding-right': '0'
      } : {}" *ngIf="!loading">
        <button *ngIf="settings.export && dataTable && dataTable.length > 0" type="button" class="btn export-button"
          (click)="exportData()" [ngbTooltip]="'Esporta in CSV'">
          <ng-container *ngIf="!settings.noOpenData; else exportText">
            <img src="assets/img/opendata.gif" alt="Open Data" width="80" height="15">
          </ng-container>
          <ng-template #exportText>
            Esporta in CSV
          </ng-template>
        </button>


        <table class="table table-striped table-responsive" *ngIf="dataTable && dataTable.length > 0">
          <thead>
            <tr>
              <ng-container *ngFor="let col of keys; index as i">
                <ng-container *ngIf="!columns[col]?.hidden">
                  <ng-container *ngIf="isSortable(col); else notSortable">
                    <th sortable (sort)="onSort($event, col)" class="text-nowrap sortable-th">
                      {{ getTitle(col) }}
                    </th>
                  </ng-container>
                  <ng-template #notSortable>
                    <th>
                      {{ getTitle(col) }}
                    </th>
                  </ng-template>
                </ng-container>
              </ng-container>
              <th scope="col" style="min-width: 6em; padding-right: 2em; text-align: end;"
                *ngIf="(settings.showActions && permittedActions.length > 0) || settings.showActionsForce">Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let val of dataTable; index as i">
              <ng-container *ngFor="let col of keys">
                <td [ngStyle]="settings.cssTd || null" *ngIf="!columns[col]?.hidden"
                  [style.padding-left.px]="isSortable(col) ? 27 : 7">
                  <ng-container *ngIf="columns[col].badge">
                    <span [ngStyle]="settings.cssSpan || null" class="badge badge-widthFixed"
                      [ngClass]="getBadgeClass(val[col], val, col)">
                      <span [ngStyle]="settings.cssSpan || null" *ngIf="columns[col]?.showIcon">
                        <ng-container *ngIf="columns['extension']" [ngSwitch]="val?.extension">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-pdf.svg"
                            alt="file pdf" *ngSwitchCase="'pdf'">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-excel.svg"
                            alt="file sheet" *ngSwitchCase="'xls'">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-excel.svg"
                            alt="file sheet" *ngSwitchCase="'xlsx'">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-zip.svg"
                            alt="file zip" *ngSwitchCase="'zip'">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-zip.svg"
                            alt="file rar" *ngSwitchCase="'rar'">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-doc.svg"
                            alt="doc" *ngSwitchDefault>
                        </ng-container>
                      </span> {{ formatValue(col, val) }}
                    </span>
                  </ng-container>
                  <ng-container *ngIf="!(columns[col].badge)">
                    <ng-container *ngIf="columns[col].linkLabel !== undefined; else noLink">
                      <ng-container *ngIf="formatValue(col, val) !== 'N/D'; else showValue">
                        <a style="text-decoration:none;display:block;text-align:center" [href]="formatValue(col, val)"
                          target="_blank" rel="noopener noreferrer">
                          {{ columns[col].linkLabel }}
                        </a>
                      </ng-container>
                    </ng-container>
                    <ng-template #showValue>
                      <span [ngStyle]="settings.cssSpan || null" *ngIf="columns[col]?.showIcon">
                        <ng-container *ngIf="columns['extension']" [ngSwitch]="val?.extension">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-pdf.svg"
                            alt="file pdf" *ngSwitchCase="'pdf'">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-excel.svg"
                            alt="file sheet" *ngSwitchCase="'xls'">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-excel.svg"
                            alt="file sheet" *ngSwitchCase="'xlsx'">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-zip.svg"
                            alt="file zip" *ngSwitchCase="'zip'">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-zip.svg"
                            alt="file rar" *ngSwitchCase="'rar'">
                          <img style="width: 20px; height: 24px; margin-right: 5px;" src="assets/svg/file-doc.svg"
                            alt="doc" *ngSwitchDefault>
                        </ng-container>
                      </span> {{ formatValue(col, val) }}
                    </ng-template>
                    <ng-template #noLink>
                      <ng-container *ngIf="columns[col].tooltip; else plainText">
                        <span [ngStyle]="settings.cssSpan || null" [ngbTooltip]="val[col]" tooltipPlacement="bottom"
                          tooltipTrigger="hover" [class.text-truncate]="!settings.noTextTruncate"
                          [ngStyle]="settings.cssSpan || null">

                          <a *ngIf="columns[col]?.link" [href]="getLink(columns[col].link, val)" target="_blank"
                            class="link-with-tooltip" style="text-decoration:none;">
                            <!-- Se c'è un'icona associata, la mostriamo prima del testo -->
                            <span [ngStyle]="settings.cssSpan || null" *ngIf="columns[col]?.showIcon">
                              <ng-container *ngIf="columns['extension']" [ngSwitch]="val?.extension">
                                <img style="width: 20px; height: 24px; margin-right: 5px;"
                                  src="assets/svg/file-pdf.svg" alt="file pdf" *ngSwitchCase="'pdf'">
                                <img style="width: 20px; height: 24px; margin-right: 5px;"
                                  src="assets/svg/file-excel.svg" alt="file sheet" *ngSwitchCase="'xls'">
                                <img style="width: 20px; height: 24px; margin-right: 5px;"
                                  src="assets/svg/file-excel.svg" alt="file sheet" *ngSwitchCase="'xlsx'">
                                <img style="width: 20px; height: 24px; margin-right: 5px;"
                                  src="assets/svg/file-zip.svg" alt="file zip" *ngSwitchCase="'zip'">
                                <img style="width: 20px; height: 24px; margin-right: 5px;"
                                  src="assets/svg/file-zip.svg" alt="file rar" *ngSwitchCase="'rar'">
                                <img style="width: 20px; height: 24px; margin-right: 5px;"
                                  src="assets/svg/file-doc.svg" alt="doc" *ngSwitchDefault>
                              </ng-container>
                            </span>
                            {{ formatValue(col, val) }}
                          </a>
                          <span [ngStyle]="settings.cssSpan || null" *ngIf="!columns[col]?.link">
                            {{ formatValue(col, val) }}
                          </span>
                        </span>
                      </ng-container>
                      <ng-template #plainText>
                        <ng-container *ngIf="columns[col].multiple; else singleValue">
                          <span [ngStyle]="settings.cssSpan || null" *ngIf="columns[col].link; else noLinkable">
                            <ng-container *ngIf="getEntries(val[col])?.length; else notAvailable">
                              <ng-container *ngFor="let entry of getEntries(val[col]); let last = last">
                                <a *ngIf="entry.key !== undefined"
                                  style="text-decoration:none; display:inline-block; margin-right: 5px;"
                                  [href]="columns[col].link!.value + '/' + entry.key" target="_blank"
                                  rel="noopener noreferrer">
                                  {{ entry.value }}
                                </a><span [ngStyle]="settings.cssSpan || null" *ngIf="!last">, </span>
                              </ng-container>
                            </ng-container>
                          </span>
                          <ng-template #noLinkable>
                            <ng-container *ngIf="getEntries(val[col])?.length; else notAvailable">
                              <ng-container *ngFor="let entry of getEntries(val[col]); let last = last">
                                <span [ngStyle]="settings.cssSpan || null" *ngIf="entry.key !== undefined"
                                  style="display:inline-block; margin-right: 5px;">
                                  {{ entry.value }}
                                </span><span [ngStyle]="settings.cssSpan || null" *ngIf="!last">, </span>
                              </ng-container>
                            </ng-container>
                          </ng-template>
                        </ng-container>

                        <ng-template #singleValue>
                          <ng-container *ngIf="columns[col].link as link">
                            <ng-container *ngIf="link.prop as prop">

                              <span [ngStyle]="settings.cssSpan || null" *ngIf="columns[col].tooltip; else noTooltip"
                                [ngbTooltip]="val[prop] || 'N/D'" tooltipPlacement="bottom" tooltipTrigger="hover"
                                [class.text-truncate]="!settings.noTextTruncate" [ngStyle]="settings.cssSpan || null">
                                <a *ngIf="val[prop] !== undefined" style="text-decoration:none; display:block;"
                                  [href]="getLinkHref(link, val)" target="_blank" rel="noopener noreferrer">
                                  <span [ngStyle]="settings.cssSpan || null" *ngIf="columns[col]?.showIcon">
                                    <ng-container *ngIf="columns['extension']" [ngSwitch]="val?.extension">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-pdf.svg" alt="file pdf" *ngSwitchCase="'pdf'">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-excel.svg" alt="file sheet" *ngSwitchCase="'xls'">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-excel.svg" alt="file sheet" *ngSwitchCase="'xlsx'">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-zip.svg" alt="file zip" *ngSwitchCase="'zip'">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-zip.svg" alt="file rar" *ngSwitchCase="'rar'">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-doc.svg" alt="doc" *ngSwitchDefault>
                                    </ng-container>
                                  </span>
                                  {{ formatValue(col, val) || 'N/D' }}
                                </a>
                              </span>

                              <ng-template #noTooltip>

                                <a *ngIf="val[prop] !== undefined" style="text-decoration:none; display:block;"
                                  [href]="link.value + '/' + val[prop]" target="_blank" rel="noopener noreferrer">
                                  <span [ngStyle]="settings.cssSpan || null" *ngIf="columns[col]?.showIcon">
                                    <ng-container *ngIf="columns['extension']" [ngSwitch]="val?.extension">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-pdf.svg" alt="file pdf" *ngSwitchCase="'pdf'">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-excel.svg" alt="file sheet" *ngSwitchCase="'xls'">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-excel.svg" alt="file sheet" *ngSwitchCase="'xlsx'">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-zip.svg" alt="file zip" *ngSwitchCase="'zip'">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-zip.svg" alt="file rar" *ngSwitchCase="'rar'">
                                      <img style="width: 20px; height: 24px; margin-right: 5px;"
                                        src="assets/svg/file-doc.svg" alt="doc" *ngSwitchDefault>
                                    </ng-container>
                                  </span>
                                  {{ formatValue(col, val) || 'N/D' }}
                                </a>
                              </ng-template>
                            </ng-container>
                          </ng-container>
                          <span [ngStyle]="settings.cssSpan || null" *ngIf="!columns[col].link">{{ formatValue(col,
                            val) || 'N/D' }}</span>
                        </ng-template>
                        <ng-template #notAvailable>
                          <span>N/D</span>
                        </ng-template>
                      </ng-template>
                    </ng-template>
                  </ng-container>
                </td>
              </ng-container>
              <td [ngStyle]="settings.cssTd || null"
                *ngIf="(settings.showActions && permittedActions.length > 0) || settings.showActionsForce"
                style="min-width: 6rem; padding-right: 1.2em; text-align: end;">
                <div ngbDropdown class="d-inline-block" container="body">
                  <button type="button" class="btn btn-primary btn-xs text-nowrap" [id]="'dropdownBasic' + (i+1)"
                    ngbDropdownToggle>
                    Azioni
                  </button>
                  <div ngbDropdownMenu [attr.aria-labelledby]="'dropdownBasic' + (i+1)">
                    <ng-template [ngIf]="!settings.actions" [ngIfElse]="actions">
                      <button ngbDropdownItem [routerLink]="editPage+'/edit/'+val.id">Modifica</button>
                      <button ngbDropdownItem>Cancella</button>
                    </ng-template>

                    <ng-template #actions>
                      <span [ngStyle]="settings.cssSpan || null" *ngFor="let row of settings.actions; index as y">
                        <a *ngIf="permittedActions.includes(row.type)" href="javascript:;" (click)="onClick(row, val)"
                          ngbDropdownItem>{{ row.title }}</a>
                      </span>
                    </ng-template>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="(!dataTable || dataTable.length === 0)" class="text-center no-data-message" style="font-size:18px">
          {{ settings.pagination.messageData }}
        </div>

      </div>


      <div
        *ngIf="!settings.pagination.hidden && dataTable && dataTable.length > 0 && data && data.length > pageSize && !settings.paginationRemote"
        class="col-12 justify-content-center">
        <ngb-pagination [collectionSize]="collectionSize" [(page)]="pageIndex" [pageSize]="pageSize" [maxSize]="maxSize"
          [rotate]="true" [boundaryLinks]="true" (pageChange)="updateDataTable({index: $event})"></ngb-pagination>
      </div>
      <div *ngIf="!settings.pagination.hidden && dataTable && dataTable.length > 0 && data && settings.paginationRemote"
        class="col-12 justify-content-center">
        <ngb-pagination [collectionSize]="collectionSize" [(page)]="pageIndex" [pageSize]="pageSize" [maxSize]="maxSize"
          [rotate]="true" [boundaryLinks]="true" (pageChange)="updateDataTableRemote({index: $event})">
        </ngb-pagination>
      </div>


    </div>
  </form>
</div>

<div *ngIf="loading || loadingPermission" style="margin-top:100px">
  <div class="progress progress-indeterminate">
    <div class="progress-bar" style="background-color: #06c" role="progressbar"></div>
  </div>
</div>